
import { useState, useEffect } from "react";
// import { supabase } from "@/integrations/supabase/client"; // Temporarily commented out
import { PartFilter } from "@/data/parts";
import { useAuth } from "@/contexts/AuthContext";
// import { Printer } from "@/types/printer"; // Not needed while we use static data

/**
 * Hook for loading and managing user preferences
 * Currently using static defaults (Supabase disabled)
 */
export const useUserPreferences = () => {
  const { user } = useAuth();
  const [minStarRating, setMinStarRating] = useState(0);
  const [defaultPrinterId, setDefaultPrinterId] = useState<string | null>(null);
  const [defaultPrinterName, setDefaultPrinterName] = useState<string | null>(null);
  const [viewMode, setViewMode] = useState<"grid" | "table">("grid");
  const [requiredFilters, setRequiredFilters] = useState<PartFilter[]>([]);
  
  // Temporarily disabled Supabase user preferences loading
  /*
  // Load user preferences when user is available
  useEffect(() => {
    const loadUserPreferences = async () => {
      if (!user) return;
      
      try {
        const { data, error } = await supabase
          .from('user_preferences')
          .select(`
            min_rating,
            default_view,
            default_printer_id,
            requirements_prefs
          `)
          .eq('id', user.id)
          .maybeSingle();
          
        if (error) {
          console.error('Error loading user preferences:', error);
          return;
        }
        
        if (data) {
          // Only update state if the data exists and is not null
          if (data.min_rating !== null) {
            setMinStarRating(data.min_rating);
          }
          
          if (data.default_view) {
            setViewMode(data.default_view as "grid" | "table");
          }
          
          if (data.default_printer_id) {
            setDefaultPrinterId(data.default_printer_id);
            
            // Fetch the printer name if we have an ID
            if (data.default_printer_id) {
              const { data: printerData, error: printerError } = await supabase
                .from('printers')
                .select('*')
                .eq('id', data.default_printer_id)
                .maybeSingle();
              
              if (!printerError && printerData) {
                // Map database column 'printer' to our interface field 'name'
                setDefaultPrinterName(printerData.printer || null);
              }
            }
          }

          // Load requirements preferences
          if (data.requirements_prefs) {
            const requirementsFilters: PartFilter[] = [];
            const prefs = data.requirements_prefs as Record<string, boolean>;
            
            // Add each filter that's true in the preferences
            if (prefs.requires_root) requirementsFilters.push("requires-root");
            if (prefs.requires_tools) requirementsFilters.push("requires-tools");
            if (prefs.wiring) requirementsFilters.push("requires-wiring");
            if (prefs.requires_printing) requirementsFilters.push("requires-printing");
            if (prefs.requires_purchase) requirementsFilters.push("requires-purchase");

            // Set the loaded filters
            setRequiredFilters(requirementsFilters);
          }
        }
      } catch (error) {
        console.error('Error loading user preferences:', error);
      }
    };
    
    loadUserPreferences();
  }, [user]);
  */

  return {
    minStarRating,
    setMinStarRating,
    defaultPrinterId,
    defaultPrinterName,
    viewMode,
    setViewMode,
    requiredFilters,
  };
};
